<template>
  <div class="header">
    <el-row type="flex" justify="center">
      <el-col :span="16">
        <div class="grid-content bg-purple-dark" v-show="showHeader">
        <!-- 已登录状态 -->
          <template v-if="loginUser && loginUser.id > 0">
            <!-- 编辑态 -->
            <template v-if="editing">
              <router-link to="/">
                <span class="iconfont icon--logo pull-left"></span>
              </router-link>
              <span class="pull-right">
                <ul class="list-inline">
                  <li class="item"
                    @click="onClickShow"
                    @mouseenter="themeStatusShow"
                    @mouseleave="themeStatusHide">
                    主题色设置
                    <color-palette
                      v-if="isMobile"
                      :showColorPalette="showColorPalette">
                    </color-palette>
                  </li>
                  <li class="item module-set">
                    <el-dropdown trigger="hover" @command="handleModules">
                      <el-button size="mini" type="text" class="el-dropdown-link">
                        模块设置<i class="el-icon-caret-bottom el-icon--right"></i>
                      </el-button>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="showModulesSet">模块排序/隐藏</el-dropdown-item>
                        <el-dropdown-item command="addModules">添加定制模块</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </li>
                  <li class="item">
                    <el-dropdown :hide-on-click=false trigger="hover">
                      <el-button size="mini" type="text" class="el-dropdown-link">
                        更多设置<i class="el-icon-caret-bottom el-icon--right"></i>
                      </el-button>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item><el-radio v-model="openAccess" label="1">公开主页</el-radio></el-dropdown-item>
                        <el-dropdown-item><el-radio v-model="openAccess" label="0">仅自己可见</el-radio></el-dropdown-item>
                        <el-dropdown-item divided>
                          <el-checkbox v-model="fixedToolNav">显示侧栏导航</el-checkbox>
                        </el-dropdown-item>
                        <el-dropdown-item>
                          <el-checkbox v-model="fixedToolQrcode">显示二维码</el-checkbox>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </li>
                  <li class="item cancel" @click="cancelEditing">
                    取消
                  </li>
                  <li class="item save" @click="saveEditing">
                    <el-button type="primary" size="small" class="no-border-radius">保存</el-button>
                  </li>
                </ul>
              </span>
            </template>
            <template v-else>
              <!-- 浏览态 -->
              <router-link to="/">
                <span class="iconfont icon--logo pull-left"></span>
              </router-link>
              <span class="pull-right">
                <el-button class="button-edit" size="mini" type="text" v-if="status === 1 && loginUser.is_self == 1 " @click="editHomepage">
                  <i class="edit-homepage iconfont icon--edit"></i>
                  编辑主页
                </el-button>
                <el-dropdown @command="handleCommand">
                  <span class="el-dropdown-link">
                    <img :src="loginUser.avatar" alt="" class="avatar">
                    {{loginUser.nickname}}<i class="el-icon-caret-bottom el-icon--right"></i>
                  </span>
                  <el-dropdown-menu class="header-dropdown-menu" slot="dropdown">
                    <template v-if="loginUser.is_self != 1">
                      <el-dropdown-item command="myHomepage">我的主页</el-dropdown-item>
                    </template>
                    <el-dropdown-item class="homepage-plan" command="homePlan">主页计划</el-dropdown-item>
                    <el-dropdown-item divided class="my-result" command="manageResults">我的成果</el-dropdown-item>
                    <el-dropdown-item divided command="goCenter">
                      <el-badge :is-dot="showDot">
                          账户中心
                      </el-badge>
                    </el-dropdown-item>
                    <el-dropdown-item command="logout">退出登录</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </span>
            </template>
          </template>
          <!-- 未登录状态 -->
          <template v-else>
            <router-link to="/">
              <span class="iconfont icon--logo pull-left"></span>
            </router-link>
            <span class="pull-right" v-if="!noUser">
              <el-button type="text" @click="loginScholar">注册/登录</el-button>
            </span>
          </template>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import colorPalette from '@/components/ColorPalette/index'
import { logout } from '@/api/index'

/**
 * 如果homepage_uid 大于 0 代表主页已经开通
 * 如果homepage_uid 等于 0 未开通主页
 */
export default {
  props: {
    editing: Boolean, // 是否处于编辑状态
    loginUser: Object, // 当前登录用户的信息
    noUser: Boolean, // 是否不显示登录用户信息 默认为false
    isMobile: Boolean, // 是否是手机端
    status: Number // 是否开通主页
  },
  data () {
    return {
      showColorPalette: false,
      showHeader: false,
      showDot: true
    }
  },
  computed: {
    openAccess: {
      get: function () {
        return String(this.$store.state.config.openAccess)
      },
      set: function (val) {
        this.$store.commit('config/changeOpenAccess', val)
        return val
      }
    },
    fixedToolNav: {
      get () {
        return Boolean(this.$store.state.config.fixedToolNav === 0)
      },
      set (val) {
        this.$store.commit('config/changeFixedToolNav', Number(!val))
      }
    },
    fixedToolQrcode: {
      get () {
        return Boolean(this.$store.state.config.fixedToolQrcode === 0)
      },
      set (val) {
        this.$store.commit('config/changeFixedToolQrcode', Number(!val))
      }
    }
  },
  mounted () {
    this.showHeader = true
    // 处理新功能提示状态
    this.handleCenterSlot()
  },
  methods: {
    handleCommand (command) {
      if (command === 'manageResults') {
        window.open(`${process.env.WEB_ORIGIN}/doc/factory/info/md/paper#paper`, '_blank')
      } else if (command === 'myHomepage') {
        // 如果有主页，则直接跳转，没有，则去创建主页  @todo
        if (this.loginUser.homepage_uid > 0) {
          window.location.href = `${window.location.origin}/${this.loginUser.id}`
        } else {
          // 弹出二维码
          this.$emit('createScholar')
        }
      } else if (command === 'homePlan') {
        this.$router.push({path: '/'})
      } else if (command === 'logout') {
        logout()
          .then((res) => {
            if (res.code === 1) {
              location.reload()
            }
          })
          .catch((err) => console.log(err))
      } else if (command === 'goCenter') {
        localStorage.setItem('scholar_center_slot', JSON.stringify(false))
        this.showDot = false
        window.open(`${process.env.WEB_ORIGIN}/index/user/personal_info?system=${process.env.SCHOLAR_ORIGIN}`)
      } else {
      }
    },
    cancelEditing () {
      this.$emit('cancelEditing')
    },
    saveEditing () {
      this.$emit('saveEditing')
    },
    onClickShow () {
      this.$emit('isClick')
    },
    themeStatusShow () {
      this.$emit('isMouseenter')
    },
    themeStatusHide () {
      this.$emit('isMouseleave')
    },
    createScholar () {
      this.$emit('createScholar')
    },
    loginScholar () {
      if (this.isMobile) {
        this.$emit('wxAuthorize')
      } else {
        this.$emit('loginScholar')
      }
    },
    handleCenterSlot () {
      var isShowDot = JSON.parse(localStorage.getItem('scholar_center_slot'))
      if (isShowDot === null) {
        this.showDot = true
      } else if (isShowDot === false) {
        this.showDot = false
      } else {
      }
    },
    editHomepage () {
      this.$emit('entryEditing', true)
    },
    handleModules (command) {
      if (command === 'showModulesSet') {
        this.$emit('sortModules')
      } else if (command === 'addModules') {
        this.$message('功能开发中，敬请期待')
      } else {
      }
    }
  },
  components: {
    colorPalette
  }
}
</script>
<style scoped lang="scss">
  @import './index.scss';
</style>
<style lang="scss">
ul.header-dropdown-menu,.el-popper {
  .el-badge__content.is-fixed.is-dot {
    right: -14px;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header/index.vue